/*
  Desktop menu ​​‍​​​‍​‌‍‍‌‌​‌​‌‍⁠‌​​‌‍​‌‌​‍​‌​​‍​‌‌‌‍​​​​‍​​‌‌‍​‌‌​‍​‌​​‍‌​​‌‍‌​​​‍​​​​‍​​​​‍​​‌​﻿‌‍‍‍‍‍‌‍‍‍‍‌‍‍‍‍​​‌
*/

/*
  Sticky header
*/
let cleanupStickyHeader = () => {};

const initStickyHeader = () => {
  cleanupStickyHeader();
  cleanupStickyHeader = () => {};

  const header = document.querySelector('#header');
  const headerSection = header?.parentElement;
  const stickyMode = header?.dataset.stickyHeader || 'always';
  const hasTransparentHeader = header?.dataset.transparentHeader === 'true';
  const defaultColorSchemeClass = header?.dataset.colorSchemeClass;
  const transparentColorScheme = header?.dataset.transparentColorScheme;
  const transparentColorSchemeClass = header?.dataset.transparentColorSchemeClass;
  let isHeaderInteracting = false;
  let transparentHeaderObserver = null;

  if (!header || !headerSection) {
    return;
  }

  header.dataset.stickyMode = stickyMode;
  headerSection.classList.remove("header-sticky", "header-hide");
  headerSection.classList.toggle("header-transparent-section", hasTransparentHeader);
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  let ticking = false;
  const scrollThreshold = 12;

  const updateTransparentHeader = () => {
    if (!hasTransparentHeader || !header) return;

    const hasOpenHeaderDisclosure = header.querySelector('[aria-expanded="true"]');
    const isActive = window.pageYOffset <= 0 && !isHeaderInteracting && !hasOpenHeaderDisclosure;

    header.dataset.transparentHeaderActive = isActive ? 'true' : 'false';

    if (transparentColorScheme !== 'inverse' || !defaultColorSchemeClass || !transparentColorSchemeClass) {
      return;
    }

    header.classList.toggle(defaultColorSchemeClass, !isActive);
    header.classList.toggle(transparentColorSchemeClass, isActive);
  };

  const updateHeaderHeight = () => {
    const headerHeight = `${header.clientHeight}px`;
    document.documentElement.style.setProperty('--header-height', headerHeight);
    document.documentElement.style.setProperty('--sticky-header-height', stickyMode === 'always' ? headerHeight : '0px');
    updateTransparentHeader();
  };

  const onHeaderEnter = () => {
    isHeaderInteracting = true;
    updateTransparentHeader();
  };

  const onHeaderLeave = () => {
    isHeaderInteracting = false;
    updateTransparentHeader();
  };

  const onHeaderFocusOut = (event) => {
    if (event.relatedTarget instanceof Node && header.contains(event.relatedTarget)) {
      return;
    }

    onHeaderLeave();
  };

  const addTransparentInteractionListeners = () => {
    if (!hasTransparentHeader) return;

    header.addEventListener("mouseenter", onHeaderEnter);
    header.addEventListener("mouseleave", onHeaderLeave);
    header.addEventListener("focusin", onHeaderEnter);
    header.addEventListener("focusout", onHeaderFocusOut);

    transparentHeaderObserver = new MutationObserver(updateTransparentHeader);
    transparentHeaderObserver.observe(header, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
      subtree: true,
    });
  };

  const removeTransparentInteractionListeners = () => {
    if (!hasTransparentHeader) return;

    header.removeEventListener("mouseenter", onHeaderEnter);
    header.removeEventListener("mouseleave", onHeaderLeave);
    header.removeEventListener("focusin", onHeaderEnter);
    header.removeEventListener("focusout", onHeaderFocusOut);
    transparentHeaderObserver?.disconnect();
    transparentHeaderObserver = null;
  };

  const onScroll = () => {
    updateTransparentHeader();

    if (stickyMode === 'always') {
      headerSection.classList.remove("header-hide");
      return;
    }

    if (ticking) {
      return;
    }

    ticking = true;

    window.requestAnimationFrame(() => {
      const currentScroll = window.pageYOffset;
      const scrollDelta = currentScroll - lastScrollTop;

      if (Math.abs(scrollDelta) < scrollThreshold) {
        ticking = false;
        return;
      }

      if (scrollDelta > 0 && currentScroll > header.clientHeight) {
        headerSection.classList.add("header-hide");
      } else {
        headerSection.classList.remove("header-hide");
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      ticking = false;
    });
  }

  addTransparentInteractionListeners();

  if (stickyMode === 'never') {
    if (hasTransparentHeader) {
      updateHeaderHeight();
    } else {
      document.documentElement.style.removeProperty('--header-height');
    }
    document.documentElement.style.setProperty('--sticky-header-height', '0px');

    updateTransparentHeader();

    if (hasTransparentHeader) {
      window.addEventListener("resize", updateHeaderHeight);
      window.addEventListener("scroll", updateTransparentHeader, { passive: true });

      cleanupStickyHeader = () => {
        headerSection.classList.remove("header-transparent-section");
        removeTransparentInteractionListeners();
        window.removeEventListener("resize", updateHeaderHeight);
        window.removeEventListener("scroll", updateTransparentHeader);
      };
    }

    return;
  }

  headerSection.classList.add("header-sticky");

  updateHeaderHeight();
  updateTransparentHeader();
  window.addEventListener("resize", updateHeaderHeight);
  window.addEventListener("scroll", onScroll, { passive: true });

  cleanupStickyHeader = () => {
    headerSection.classList.remove("header-sticky", "header-hide", "header-transparent-section");
    if (defaultColorSchemeClass && transparentColorSchemeClass) {
      header.classList.add(defaultColorSchemeClass);
      header.classList.remove(transparentColorSchemeClass);
    }
    removeTransparentInteractionListeners();
    window.removeEventListener("resize", updateHeaderHeight);
    window.removeEventListener("scroll", onScroll);
  };
}
initStickyHeader();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#header')) {
    initStickyHeader();
  }
});


/*
  Mobile menu
*/
const initMobileMenu = () => {
  const headerMobile = document.querySelector('#header-mobile');
  const mobileMenu = document.querySelector('#header-mobile-menu');
  const toggleButton = document.querySelector('[data-toggle="header-mobile-menu"]'); 

  if (!mobileMenu || !toggleButton) {
    return;
  }

  const scrollToActiveCollectionItem = () => {
    const collectionList = mobileMenu.querySelector('.collection-list');
    const activeCollectionItem = collectionList?.querySelector('a.active');

    if (!collectionList || !activeCollectionItem) {
      return;
    }

    const listRect = collectionList.getBoundingClientRect();
    const activeRect = activeCollectionItem.getBoundingClientRect();
    const offset = activeRect.left - listRect.left - (listRect.width / 2) + (activeRect.width / 2);
    collectionList.scrollLeft += offset;
  };

  if (mobileMenu.hidden) {
    mobileMenu.style.visibility = 'hidden';
    mobileMenu.hidden = false;
    scrollToActiveCollectionItem();
    mobileMenu.hidden = true;
    mobileMenu.style.visibility = '';
  } else {
    scrollToActiveCollectionItem();
  }

  const shouldAnimateMobileMenu = () => (
    mobileMenu.dataset.animateOnScroll === 'true' &&
    document.documentElement.dataset.designMode !== 'true' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  const revealMobileMenuAnimations = () => {
    if (!mobileMenu.hasAttribute('data-animate-on-scroll')) return;

    if (!shouldAnimateMobileMenu()) {
      mobileMenu.dataset.viewportEntered = 'true';
      return;
    }

    mobileMenu.dataset.viewportEntered = 'false';
    mobileMenu.getBoundingClientRect();

    window.requestAnimationFrame(() => {
      mobileMenu.dataset.viewportEntered = 'true';
    });
  };

  const updateMobileMenuTop = () => {
    const header = document.querySelector('#header');
    const headerRect = header?.getBoundingClientRect();
    const top = headerRect ? Math.max(headerRect.bottom, 0) : 0;

    mobileMenu.style.setProperty('--top', `${top}px`);
  };

  const openMenu = () => {
    toggleButton.setAttribute('aria-expanded', 'true');
    updateMobileMenuTop();
    mobileMenu.hidden = false;
    revealMobileMenuAnimations();
    document.body.style.overflow = 'hidden';
    window.addEventListener('resize', updateMobileMenuTop);
    window.addEventListener('scroll', updateMobileMenuTop, { passive: true });
    
    headerMobile.querySelectorAll('a, button').forEach((el) => {
      if (el !== toggleButton) {
        el.setAttribute('tabindex', '-1');
      }
    });
  };

  const closeMenu = () => {
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.focus();
    mobileMenu.hidden = true;
    if (mobileMenu.hasAttribute('data-animate-on-scroll')) {
      mobileMenu.dataset.viewportEntered = 'false';
    }
    document.body.style.overflow = '';
    window.removeEventListener('resize', updateMobileMenuTop);
    window.removeEventListener('scroll', updateMobileMenuTop);

    headerMobile.querySelectorAll('a, button').forEach((el) => {
      el.removeAttribute('tabindex');
    });
  };

  toggleButton.addEventListener('click', () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  mobileMenu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !event.target.closest('.submenu')) {
      closeMenu();
    }
  });

  document.addEventListener('click', (event) => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    if (isExpanded && !mobileMenu.contains(event.target) && !toggleButton.contains(event.target)) {
      closeMenu();
    }
  });

  const submenuToggles = mobileMenu.querySelectorAll('[data-submenu-toggle]');
  const submenus = mobileMenu.querySelectorAll('.submenu');
  const backButtons = mobileMenu.querySelectorAll('[data-back-button]');

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const isKeyboard = event.detail === 0;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      if (isKeyboard && !isExpanded) {
        const submenu = toggle.nextElementSibling;
        setTimeout(() => {
          submenu.querySelector('a, button')?.focus();
        }, 300);
      }
    });
  });

  submenus.forEach((submenu) => {
    submenu.addEventListener('keydown', (event) => {
      const toggle = submenu.previousElementSibling
      if (event.key === 'Escape') {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });

  backButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        const submenu = button.closest('.submenu');
        const toggle = submenu.previousElementSibling;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }, 200);
    });
  });

  mobileMenu.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    
    let focusableElements, firstElement, lastElement;

    if (event.target.closest('.submenu')) {
      const submenu = event.target.closest('.submenu');
      focusableElements = submenu.querySelectorAll('a, button');
      firstElement = focusableElements[0];
      lastElement = focusableElements[focusableElements.length - 1];
    } else {
      mobileMenu.querySelectorAll('a, button').forEach((el) => {
        if (!el.closest('.submenu')) {
          el.setAttribute('tabindex', '0');
        }
      });
      focusableElements = mobileMenu.querySelectorAll('a, button');
      firstElement = toggleButton;
      lastElement = focusableElements[focusableElements.length - 1];
    }

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  });
}
initMobileMenu();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#header-mobile-menu')) {
    initMobileMenu();
  }
});


/*
  Desktop menu
*/
const initDesktopMenu = () => {
  const desktopMenu = document.querySelector('#header-desktop-menu');

  if (!desktopMenu) {
    return;
  }

  const dropdownToggles = desktopMenu.querySelectorAll('[data-dropdown-toggle]');
  const dropdownMenus = desktopMenu.querySelectorAll('.dropdown-menu, .dropdown-megamenu');
  const closeTimers = new Map();

  const clearCloseTimer = (toggle) => {
    const closeTimer = closeTimers.get(toggle);

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimers.delete(toggle);
    }
  };

  const scheduleClose = (toggle) => {
    clearCloseTimer(toggle);
    closeTimers.set(toggle, setTimeout(() => {
      toggle.setAttribute('aria-expanded', 'false');
      closeTimers.delete(toggle);
    }, 120));
  };

  const closeDropdowns = (currentToggle = null) => {
    dropdownToggles.forEach((toggle) => {
      if (toggle !== currentToggle) {
        clearCloseTimer(toggle);
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const openDropdown = (toggle) => {
    clearCloseTimer(toggle);
    closeDropdowns(toggle);
    toggle.setAttribute('aria-expanded', 'true');
  };

  const focusFirstDropdownLink = (toggle) => {
    const dropdownMenu = document.getElementById(toggle.getAttribute('aria-controls'));
    const firstLink = dropdownMenu?.querySelector('a[href]');

    if (firstLink) {
      firstLink.focus();
    }
  };

  dropdownToggles.forEach((toggle) => {
    const navItem = toggle.closest('.nav-item');

    if (navItem) {
      navItem.addEventListener('mouseenter', () => {
        openDropdown(toggle);
      });

      navItem.addEventListener('mouseleave', () => {
        scheduleClose(toggle);
      });

      navItem.addEventListener('focusin', () => {
        openDropdown(toggle);
      });

      navItem.addEventListener('focusout', (event) => {
        if (!navItem.contains(event.relatedTarget)) {
          scheduleClose(toggle);
        }
      });
    }

    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openDropdown(toggle);
        focusFirstDropdownLink(toggle);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        clearCloseTimer(toggle);
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  dropdownMenus.forEach((dropdownMenu) => {
    dropdownMenu.addEventListener('keydown', (event) => {
      const toggle = dropdownMenu.previousElementSibling
      if (event.key === 'Escape') {
        clearCloseTimer(toggle);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });
  
  document.addEventListener('click', (event) => {
    if (!desktopMenu.contains(event.target)) {
      closeDropdowns();
    }
  });
}
initDesktopMenu();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#header-desktop-menu')) {
    initDesktopMenu();
  }
});
  
